const getRowData = (translate, events, gameGroup = [], games = []) => {
    const getWppbPlusMinus = (wppb, pwppbalt, pitches) => {
        if (pwppbalt === 0) {
            return null;
        }
        return ((wppb - pwppbalt) / pitches) * -0.25;
    };

    const getTotals = (e) => {
        const totals = e.reduce((sum, x) => ({
            adv: sum.adv + x.advr,
            twok: sum.twok + x.twok,
            twokwppb: sum.twokwppb + x.twokwppb,
            twokpwppbalt: sum.twokpwppbalt + x.twokpwppbalt,
            r1: sum.r1 + x.r1,
            r1wppb: sum.r1wppb + x.r1wppb,
            r1pwppbalt: sum.r1pwppbalt + x.r1pwppbalt,
            r2: sum.r2 + x.r2,
            r2wppb: sum.r2wppb + x.r2wppb,
            r2pwppbalt: sum.r2pwppbalt + x.r2pwppbalt,
            r3: sum.r3 + x.r3,
            r3wppb: sum.r3wppb + x.r3wppb,
            r3pwppbalt: sum.r3pwppbalt + x.r3pwppbalt,
            r13: sum.r13 + x.r13,
            r13wppb: sum.r13wppb + x.r13wppb,
            r13pwppbalt: sum.r13pwppbalt + x.r13pwppbalt,
            gloveside: sum.gloveside + x.gloveside,
            glovesidewppb: sum.glovesidewppb + x.glovesidewppb,
            glovesidepwppbalt: sum.glovesidepwppbalt + x.glovesidepwppbalt,
            middle: sum.middle + x.middle,
            middlewppb: sum.middlewppb + x.middlewppb,
            middlepwppbalt: sum.middlepwppbalt + x.middlepwppbalt,
            armside: sum.armside + x.armside,
            armsidewppb: sum.armsidewppb + x.armsidewppb,
            armsidepwppbalt: sum.armsidepwppbalt + x.armsidepwppbalt,
            short: sum.short + x.short,
            shortwppb: sum.shortwppb + x.shortwppb,
            shortpwppbalt: sum.shortpwppbalt + x.shortpwppbalt,
            long: sum.long + x.long,
            longwppb: sum.longwppb + x.longwppb,
            longpwppbalt: sum.longpwppbalt + x.longpwppbalt,
            fb: sum.fb + x.fb,
            fbwppb: sum.fbwppb + x.fbwppb,
            fbpwppbalt: sum.fbpwppbalt + x.fbpwppbalt,
            cb: sum.cb + x.cb,
            cbwppb: sum.cbwppb + x.cbwppb,
            cbpwppbalt: sum.cbpwppbalt + x.cbpwppbalt,
            slcut: sum.slcut + x.slcut,
            slcutwppb: sum.slcutwppb + x.slcutwppb,
            slcutpwppbalt: sum.slcutpwppbalt + x.slcutpwppbalt,
            chspl: sum.chspl + x.chspl,
            chsplwppb: sum.chsplwppb + x.slcutwppb,
            chsplpwppbalt: sum.chsplpwppbalt + x.chsplpwppbalt,
        }), {
            adv: 0,
            twok: 0,
            twokwppb: 0,
            twokpwppbalt: 0,
            r1: 0,
            r1wppb: 0,
            r1pwppbalt: 0,
            r2: 0,
            r2wppb: 0,
            r2pwppbalt: 0,
            r3: 0,
            r3wppb: 0,
            r3pwppbalt: 0,
            r13: 0,
            r13wppb: 0,
            r13pwppbalt: 0,
            gloveside: 0,
            glovesidewppb: 0,
            glovesidepwppbalt: 0,
            middle: 0,
            middlewppb: 0,
            middlepwppbalt: 0,
            armside: 0,
            armsidewppb: 0,
            armsidepwppbalt: 0,
            short: 0,
            shortwppb: 0,
            shortpwppbalt: 0,
            long: 0,
            longwppb: 0,
            longpwppbalt: 0,
            fb: 0,
            fbwppb: 0,
            fbpwppbalt: 0,
            cb: 0,
            cbwppb: 0,
            cbpwppbalt: 0,
            slcut: 0,
            slcutwppb: 0,
            slcutpwppbalt: 0,
            chspl: 0,
            chsplwppb: 0,
            chsplpwppbalt: 0,
        });

        const pitches = events.length;

        const twokwppm = getWppbPlusMinus(totals.twokwppb, totals.twokpwppbalt, pitches);
        const r1wppm = getWppbPlusMinus(totals.r1wppb, totals.r1pwppbalt, pitches);
        const r2wppm = getWppbPlusMinus(totals.r2wppb, totals.r2pwppbalt, pitches);
        const r3wppm = getWppbPlusMinus(totals.r3wppb, totals.r3pwppbalt, pitches);
        const r13wppm = getWppbPlusMinus(totals.r13wppb, totals.r13pwppbalt, pitches);

        const glovesidewppm = getWppbPlusMinus(totals.glovesidewppb, totals.glovesidepwppbalt, pitches);
        const middlewppm = getWppbPlusMinus(totals.middlewppb, totals.middlepwppbalt, pitches);
        const armsidewppm = getWppbPlusMinus(totals.armsidewppb, totals.armsidepwppbalt, pitches);

        const shortwppm = getWppbPlusMinus(totals.shortwppb, totals.shortpwppbalt, pitches);
        const longwppm = getWppbPlusMinus(totals.longwppb, totals.longpwppbalt, pitches);

        const fbwppm = getWppbPlusMinus(totals.fbwppb, totals.fbpwppbalt, pitches);
        const cbwppm = getWppbPlusMinus(totals.cbwppb, totals.cbpwppbalt, pitches);
        const slcutwppm = getWppbPlusMinus(totals.slcutwppb, totals.slcutpwppbalt, pitches);
        const chsplwppm = getWppbPlusMinus(totals.chsplwppb, totals.chsplpwppbalt, pitches);

        return { ...totals, twokwppm, r1wppm, r2wppm, r3wppm, r13wppm, glovesidewppm, middlewppm, armsidewppm, shortwppm, longwppm, fbwppm, cbwppm, slcutwppm, chsplwppm };
    };

    if (gameGroup.length > 0) {
        const pitchesindirt = events.length;
        const { out, wppbrv } = games.filter((g) => gameGroup.indexOf(g.gameid) > -1).reduce((sum, x) => ({
            out: sum.out + x.out,
            wppbrv: sum.wppbrv + x.wppbrv,
        }), { out: 0, wppbrv: 0 });

        const firstGame = games.find((g) => g.gameid === gameGroup[0]);
        const lastGame = games.find((g) => g.gameid === gameGroup[gameGroup.length - 1]);
        const label = `${translate('format.datetime', { val: new Date(firstGame.gamedate), formatParams: { val: { month: 'numeric', day: 'numeric' } }, interpolation: { escapeValue: false } })}-${translate('format.datetime', { val: new Date(lastGame.gamedate), formatParams: { val: { month: 'numeric', day: 'numeric' } }, interpolation: { escapeValue: false } })} (${gameGroup.length} Gm)`;

        const totals = getTotals(events);

        totals.outs = out;
        totals.wppbrv = wppbrv;
        totals.g = gameGroup.length;
        totals.pitchesindirt = pitchesindirt;
        totals.label = label;

        return totals;
    }

    return getTotals(events);
};

const getSplitRows = (translate, filteredEvents) => {
    // Totals
    const situation = getRowData(translate, filteredEvents);
    const shortEvents = filteredEvents.filter((e) => e.short === 1);
    const short = getRowData(translate, shortEvents);
    const shortFB = getRowData(translate, shortEvents.filter((e) => [1, 9, 10].indexOf(e.pitchtype) > -1));
    const shortCB = getRowData(translate, shortEvents.filter((e) => e.pitchtype === 2));
    const shortSlCut = getRowData(translate, shortEvents.filter((e) => [3, 8].indexOf(e.pitchtype) > -1));
    const shortChSpl = getRowData(translate, shortEvents.filter((e) => [4, 7].indexOf(e.pitchtype) > -1));

    const longEvents = filteredEvents.filter((e) => e.long === 1);
    const long = getRowData(translate, longEvents);
    const longFB = getRowData(translate, longEvents.filter((e) => [1, 9, 10].indexOf(e.pitchtype) > -1));
    const longCB = getRowData(translate, longEvents.filter((e) => e.pitchtype === 2));
    const longSlCut = getRowData(translate, longEvents.filter((e) => [3, 8].indexOf(e.pitchtype) > -1));
    const longChSpl = getRowData(translate, longEvents.filter((e) => [4, 7].indexOf(e.pitchtype) > -1));

    return {
        situation,
        short,
        shortFB: { ...shortFB, label: translate('baseball.pitches.abbr-fastball'), pitchtype: 'fb' },
        shortCB: { ...shortCB, label: translate('baseball.pitches.abbr-curveball'), pitchtype: 'cb' },
        shortSlCut: { ...shortSlCut, label: `${translate('baseball.pitches.abbr-slider')}/${translate('baseball.pitches.abbr-cutter')}`, pitchtype: 'slcut' },
        shortChSpl: { ...shortChSpl, label: `${translate('baseball.pitches.abbr-changeup')}/${translate('baseball.pitches.abbr-splitter')}`, pitchtype: 'chspl' },
        long,
        longFB: { ...longFB, label: translate('baseball.pitches.abbr-fastball'), pitchtype: 'fb' },
        longCB: { ...longCB, label: translate('baseball.pitches.abbr-curveball'), pitchtype: 'cb' },
        longSlCut: { ...longSlCut, label: `${translate('baseball.pitches.abbr-slider')}/${translate('baseball.pitches.abbr-cutter')}`, pitchtype: 'slcut' },
        longChSpl: { ...longChSpl, label: `${translate('baseball.pitches.abbr-changeup')}/${translate('baseball.pitches.abbr-splitter')}`, pitchtype: 'chspl' },
    };
};

export {
    getRowData,
    getSplitRows,
};
